// src/components/AuthPage.js
import React, { Component } from 'react';
import LeftPanel from './LeftPanel';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import Icon from './Icon';

class AuthPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'login',   // 'login' | 'signup'
    };
  }

  switchTab(tab) {
    this.setState({ activeTab: tab });
  }

  render() {
    const { activeTab } = this.state;
    const { onLogin } = this.props;
    const isLogin = activeTab === 'login';

    return (
      <div className="auth-root">

        {/* ── Left decorative panel ── */}
        <LeftPanel />

        {/* ── Right form panel ── */}
        <div className="auth-right">
          <div className="auth-form-wrap">

            {/* Tab switcher */}
            <div className="auth-tabs">
              {/* Sliding highlight */}
              <div className={`auth-tab-slider${isLogin ? '' : ' right'}`} />

              <button
                type="button"
                className={`auth-tab-btn${isLogin ? ' active' : ''}`}
                onClick={() => this.switchTab('login')}
              >
                Sign In
              </button>
              <button
                type="button"
                className={`auth-tab-btn${!isLogin ? ' active' : ''}`}
                onClick={() => this.switchTab('signup')}
              >
                Create Account
              </button>
            </div>

            {/* Form content */}
            {isLogin ? (
              <LoginForm
                key="login"
                onLogin={onLogin}
              />
            ) : (
              <SignupForm
                key="signup"
                onSwitchToLogin={() => this.switchTab('login')}
              />
            )}

            {/* Footer */}
            <p className="auth-footer">
              {isLogin ? (
                <>
                  Don't have an account?{' '}
                  <a href="#signup" onClick={e => { e.preventDefault(); this.switchTab('signup'); }}>
                    Create one free
                  </a>
                </>
              ) : (
                <>
                  Already have an account?{' '}
                  <a href="#login" onClick={e => { e.preventDefault(); this.switchTab('login'); }}>
                    Sign in here
                  </a>
                </>
              )}
              <span className="auth-footer-copy">
                © 2026 DG Doctor Hospital Management System 
              </span>
            </p>

          </div>
        </div>

      </div>
    );
  }
}

export default AuthPage;
